import {
  faBullhorn,
  faCheck,
  faChevronRight,
  faCircleExclamation,
  faCopyright,
  faEllipsis,
  faHeart,
  faTimes,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import Button from "../button";

const reportReasons = [
  { value: "harassment", label: "harassment", icon: faCircleExclamation },
  {
    value: "harmfulcontent",
    label: "harmfulContent",
    icon: faTriangleExclamation,
  },
  {
    value: "inappropriatecontent",
    label: "sexualInappropriateContent",
    icon: faHeart,
  },
  { value: "spam", label: "spamMisleading", icon: faBullhorn },
  {
    value: "copyright",
    label: "copyrightIntellectualProperty",
    icon: faCopyright,
  },
  { value: "other", label: "other", icon: faEllipsis },
];

const ReportModal = ({
  show,
  onHide,
  t,
  reportReason,
  setReportReason,
  reportDetails,
  setReportDetails,
  submitReport,
  isReporting,
  themeVars,
  modalClassName = "global-themed-modal",
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    if (!show) setIsSubmitted(false);
  }, [show]);

  const handleSubmit = async () => {
    if (await submitReport()) setIsSubmitted(true);
  };

  const handleClose = () => {
    setReportReason("");
    setReportDetails("");
    setIsSubmitted(false);
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      scrollable
      className={`${modalClassName} report-post-modal`}
      dialogClassName="report-post-modal-dialog"
      style={themeVars}
    >
      <Modal.Header className="report-post-modal-header border-0 p-0">
        <Modal.Title className="report-post-modal-title">
          {t("reportPost")}
        </Modal.Title>
        <button
          type="button"
          className="report-post-modal-close"
          aria-label="Close"
          onClick={handleClose}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </Modal.Header>
      {isSubmitted ? (
        <>
          <Modal.Body className="report-success-body">
            <div className="report-success-icon" aria-hidden="true">
              <FontAwesomeIcon icon={faCheck} />
            </div>
            <h2>{t("reportSubmittedTitle")}</h2>
            <p>{t("reportSubmittedMessage")}</p>
          </Modal.Body>
          <Modal.Footer className="">
            <Button
              className="site-btn w-100"
              onClick={handleClose}
              text={t("done")}
            />
          </Modal.Footer>
        </>
      ) : (
        <>
          <Modal.Body className="report-reasons-body">
            <p className="report-reasons-prompt">{t("reasonForReporting")}</p>
            <div className="report-reason-list">
              {reportReasons.map(({ value, label, icon }) => (
                <button
                  type="button"
                  className={`report-reason-option ${reportReason === value ? "selected" : ""}`}
                  key={value}
                  aria-pressed={reportReason === value}
                  onClick={() => setReportReason(value)}
                >
                  <FontAwesomeIcon icon={icon} className="report-reason-icon" />
                  <span>{t(label)}</span>
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    className="report-reason-chevron"
                  />
                </button>
              ))}
            </div>

            {reportReason === "other" && (
              <Form.Group className="mt-3">
                <Form.Label>{t("additionalDetails")}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder={t("describeIssue")}
                  value={reportDetails}
                  onChange={(e) => setReportDetails(e.target.value)}
                />
              </Form.Group>
            )}
          </Modal.Body>
          <Modal.Footer className="">
            <Button
              nosite
              className="site-btn border-btn"
              onClick={handleClose}
              text={t("cancel")}
            />
            <Button
              className="site-btn"
              onClick={handleSubmit}
              disabled={isReporting || !reportReason}
              loading={isReporting}
              text={isReporting ? t("reporting") : t("submitReport")}
            />
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
};

export default ReportModal;
